import * as React from 'react';
import { SVGProps } from 'react';

const SvgMinimize = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="m4.945 20.495-1.443-1.443 2.857-2.857-2.814-2.814 7.042.029.029 7.043-2.814-2.814-2.857 2.857zM19.075 3.5l1.443 1.443L17.661 7.8l2.814 2.814-7.041-.027-.03-7.044 2.814 2.814L19.075 3.5z" />
  </svg>
);

export default SvgMinimize;
